import Snackbar from '@mui/material/Snackbar';
import AlertMui from '@mui/material/Alert';

import { styled } from './lib';

const Alert = ({ type, message, onClose }) => (
  <Snackbar
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    onClose={onClose}
    open={Boolean(message)}
  >
    <AlertStyled onClose={onClose} severity={type} variant="filled" type={type}>
      {message}
    </AlertStyled>
  </Snackbar>
);

export default Alert;

const AlertStyled = styled(AlertMui)(({ type }) => ({
  width: '100%',
  ...(type === 'updating' && {
    backgroundColor: '#212121',
    color: '#fff',
  }),
}));
